module.exports = __webpack_public_path__ + "img/4.4e6b7d8b.jpg";